import React from 'react'
import {
  Package,
  Edit3,
  ArrowUpRight,
  Settings,
  ChevronUp,
  ChevronDown
} from 'lucide-react'

/**
 * PowerClip and Advanced Controls Component
 * Handles PowerClip functionality and advanced properties toggle for all elements
 */
const PowerClipAdvancedControls = ({
  element,
  powerClipMode,
  powerClipContent,
  showAdvancedTextProperties,
  setShowAdvancedTextProperties,
  startPowerClip,
  applyPowerClip,
  editPowerClip,
  extractPowerClipContents
}) => {
  return (
    <div className="border-t border-gray-200 pt-3 mt-3">
      <div className="space-y-3">
        {/* PowerClip Section Header */}
        <div className="flex items-center">
          <span className="text-sm font-medium text-gray-700">PowerClip:</span>
        </div>

        {/* PowerClip Inside button - First Row */}
        {!powerClipMode && (
          <div className="flex justify-start">
            <button
              onClick={() => startPowerClip(element.id)}
              className="flex items-center space-x-2 px-3 py-1.5 bg-blue-100 hover:bg-blue-200 text-blue-700 rounded-lg text-sm transition-colors"
              title={element.isPowerClipContainer ? "PowerClip This Container Inside Another Shape" : "PowerClip Inside Shape"}
            >
              <Package className="w-4 h-4" />
              <span>{element.isPowerClipContainer ? 'Nest PowerClip' : 'PowerClip Inside'}</span>
            </button>
          </div>
        )}

        {/* PowerClip Inside Me button - Second Row (when in PowerClip mode) */}
        {powerClipMode && powerClipContent && element.type === 'shape' && (
          <div className="flex justify-start">
            <button
              onClick={() => applyPowerClip(element.id)}
              className="flex items-center space-x-2 px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-lg text-sm font-medium transition-colors shadow-md"
              title={`PowerClip ${powerClipContent.type} inside this shape`}
            >
              <Package className="w-4 h-4" />
              <span>PowerClip Inside Me</span>
            </button>
          </div>
        )}

        {/* PowerClip container controls - Third Row (Edit PowerClip) */}
        {element.isPowerClipContainer && (
          <div className="flex justify-start">
            <button
              onClick={() => editPowerClip(element.id)}
              className="flex items-center space-x-2 px-3 py-1.5 bg-green-100 hover:bg-green-200 text-green-700 rounded-lg text-sm transition-colors"
              title="Edit PowerClip Contents"
            >
              <Edit3 className="w-4 h-4" />
              <span>Edit PowerClip</span>
            </button>
          </div>
        )}

        {/* PowerClip container controls - Fourth Row (Extract Contents) */}
        {element.isPowerClipContainer && (
          <div className="flex justify-start">
            <button
              onClick={() => extractPowerClipContents(element.id)}
              className="flex items-center space-x-2 px-3 py-1.5 bg-orange-100 hover:bg-orange-200 text-orange-700 rounded-lg text-sm transition-colors"
              title="Extract PowerClip Contents"
            >
              <ArrowUpRight className="w-4 h-4" />
              <span>Extract Contents</span>
            </button>
          </div>
        )}

        {/* Advanced Properties Toggle - Hidden for text elements */}
      </div>
    </div>
  )
}

export default PowerClipAdvancedControls
